// extracted by mini-css-extract-plugin
export default {"smart-insights-row":"templates-hotel-module__smart-insights-row","smart-insights-react-mount":"templates-hotel-module__smart-insights-react-mount"};